var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1959 7.22831C19.6073 7.78511 19.1344 8.47786 18.4421 8.47786H2.83301C2.28072 8.47786 1.83301 8.03015 1.83301 7.47786V5.8837C1.83301 3.64703 3.64801 1.83203 5.88467 1.83203H8.01134C9.50551 1.83203 9.97301 2.31786 10.5688 3.11536L11.8522 4.82036C12.1363 5.1962 12.173 5.24203 12.7047 5.24203H15.2622C16.8739 5.24203 18.3051 6.02269 19.1959 7.22831Z",
    fill: "#FFB830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1514 9.85548C19.7023 9.85547 20.1495 10.3011 20.1514 10.8521L20.1663 15.264C20.1663 17.9682 17.9663 20.1682 15.2622 20.1682H6.73717C4.03301 20.1682 1.83301 17.9682 1.83301 15.264V10.8557C1.83301 10.3034 2.28071 9.85571 2.83299 9.8557L19.1514 9.85548Z",
    fill: "#FFB830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.31abab87063bf3c8fea15c7ffc8338fe.svg";
export { ForwardRef as ReactComponent };